import * as React from 'react';
import { createFragmentContainer, graphql, QueryRenderer } from 'react-relay';
import { Environment } from 'relay-runtime';
import { NewsletterForm } from './NewsletterFormUI';

const NewsletterFormContainer = createFragmentContainer(NewsletterForm, {
  user: graphql`
    fragment NewsletterForm_user on User {
      id
      userId
      firstName
      email
      hashedEmail
      lastName
      conciergeUser {
        id
        email
      }
      shoppingWithCeoUser {
        id
        email
        customUrl
        trinityDealerId
      }
      permissions {
        id
        oneCommerce {
          id
          ceo {
            access
          }
          admin {
            access
          }
          preferredCustomer {
            access
          }
        }
      }
    }
  `,
});

const noVariables = {};
// eslint-disable-next-line react/display-name
export default ({
  environment,
  multiRow,
  containerWidth,
}: {
  query: any | null;
  environment: Environment;
  containerWidth: number;
  multiRow?: boolean;
}) => {
  return (
    <QueryRenderer
      dataFrom="STORE_THEN_NETWORK"
      variables={noVariables}
      environment={environment}
      query={graphql`
        query NewsletterFormQuery {
          viewer {
            id
            id
            user {
              id
              id
              ...NewsletterForm_user
            }
          }
        }
      `}
      render={({ error, props: propsFromRender }: any) => {
        if (error) {
          return <div />;
        }
        if (
          propsFromRender &&
          propsFromRender.viewer &&
          propsFromRender.viewer.user
        ) {
          return (
            <NewsletterFormContainer
              multiRow={multiRow}
              containerWidth={containerWidth}
              user={propsFromRender.viewer.user}
              environment={environment}
            />
          );
        }

        return null;
      }}
    />
  );
};
